import { buildClientTheme, storeClientTheme } from "./clientTheme";

export const persistAuthenticatedUserSession = (user = {}) => {
    sessionStorage.setItem("firstAccess", user.firstAccess ?? 0);
    sessionStorage.setItem("idClient", user.idClient ?? 0);
    sessionStorage.setItem("token", user.jwtToken ?? "");
    sessionStorage.setItem("userId", user.id ?? 0);
    sessionStorage.setItem("username", user.username ?? "");
    sessionStorage.setItem("role", user.role ?? 0);
    sessionStorage.setItem("blocked", user.blocked ?? 0);
    sessionStorage.setItem("status", user.status ?? 0);
    sessionStorage.setItem("roleDescription", user.roleDescription ?? "");
    sessionStorage.setItem("userImage", user.base64Image ?? "");
    sessionStorage.setItem("versionNumber", user.versionNumber ?? "");
    sessionStorage.setItem("nameClient", user.nameClient ?? "");

    storeClientTheme(buildClientTheme(user));
};

export const clearAuthenticatedSession = () => {
    sessionStorage.clear();
};